import React, { useEffect, useState, useContext } from 'react';
import { NotificationContext } from './index'

// Define las props y sus tipos
interface PendingChecklistModalProps {
    surveys: any[]
}


const PendingChecklistTrigger  = ({ surveys }: PendingChecklistModalProps) => {

    const { modalVisible, setModalVisible, setModalType, setModalMessage } = useContext(NotificationContext);


    useEffect(() => {

        if(surveys && surveys.length > 0){

            setModalVisible(true);
            setModalType('warning');
        
            let message_html = `
                <p><strong>Usted tiene encuestas pendientes por responder:</strong></p>
                <table style="width: 100%; border-collapse: collapse; text-align: left;">
                    <thead>
                        <tr style="background-color: #f4f4f4; border-bottom: 2px solid #ddd;">
                            <th style="padding: 10px; border-bottom: 1px solid #ddd;">Fecha</th>
                            <th style="padding: 10px; border-bottom: 1px solid #ddd;">Encuesta</th>
                            <th style="padding: 10px; border-bottom: 1px solid #ddd;">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            surveys.forEach((survey: any) => {
                const eventId = survey.event_id || survey.parent_event_id;
                const surveyName = survey.survey_name || "Encuesta desconocida";

                const url = `/calendar-by-worker/${eventId}/event/show?start_date=${survey.date}&end_date=${survey.date}&admin=false&tab=checklists-data`;

                message_html += `
                    <tr style="border-bottom: 1px solid #ddd;">
                        <td style="padding: 10px;">${survey.date}</td>
                        <td style="padding: 10px;">${surveyName}</td>
                        <td style="padding: 10px;"><a href="${url}" style="color: #183540; text-decoration: none; font-weight: bold;">Responder</a></td>
                    </tr>
                `;
            });
        
            message_html += `
                    </tbody>
                </table>
                <p style="margin-top: 10px;">
                    ⚠️ Por favor, responda las encuestas pendientes.
                </p>
            `;

            setModalMessage(message_html);

        }

    }, [surveys]);
                


     return null; 
};

export default PendingChecklistTrigger ;
